import React from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
const ServiceThree = () => {
  let settings = {
    dots: true,
    arrows: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    speed: 500,
    autoplaySpeed: 5000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <div className="service-area-2 space-bottom">
      <div className="container">
        <div className="row align-items-end">
          <div className="col-lg-5">
            <div className="title-area">
              <span className="sub-title">
                <img src="assets/img/icon/title_left.svg" alt="shape" />
                Our Services
              </span>
              <h2 className="sec-title style2">Comprehensive Technology Solutions</h2>
            </div>
          </div>
          <div className="col-lg-7">
            <div className="service-title-area">
              <p className="">
                We provide comprehensive IT services, hardware solutions, government-focused 
                technologies, and AI-driven innovation across multiple industries and sectors.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row gx-30 global-carousel service-slider2">
          <Slider {...settings}>
            <div className="p-3">
              <div className="service-box">
                <div className="service-box_content">
                  <div className="service-box_icon">
                    <img src="assets/img/icon/service-icon_1-1.svg" alt="img" />
                  </div>
                  <h4 className="service-box_title h5">
                    <Link to="/service-details">IT Solutions & Services</Link>
                  </h4>
                  <p className="service-box_text">
                    Application development, system integration, cloud solutions, 
                    and enterprise IT support tailored to diverse industries.
                  </p>
                  <Link
                    to="/service-details"
                    className="global-btn style-border"
                  >
                    Read More{" "}
                    <img src="assets/img/icon/right-icon2.svg" alt="B Plus Technology" />
                  </Link>
                </div>
              </div>
            </div>
            <div className="p-3">
              <div className="service-box">
                <div className="service-box_content">
                  <div className="service-box_icon">
                    <img src="assets/img/icon/service-icon_1-2.svg" alt="img" />
                  </div>
                  <h4 className="service-box_title h5">
                    <Link to="/service-details">Hardware Solutions</Link>
                  </h4>
                  <p className="service-box_text">
                    End-to-end hardware solutions including procurement, installation, 
                    integration, and maintenance for enterprise infrastructure.
                  </p>
                  <Link
                    to="/service-details"
                    className="global-btn style-border"
                  >
                    Read More
                    <img src="assets/img/icon/right-icon2.svg" alt="B Plus Technology" />
                  </Link>
                </div>
              </div>
            </div>
            <div className="p-3">
              <div className="service-box">
                <div className="service-box_content">
                  <div className="service-box_icon">
                    <img src="assets/img/icon/service-icon_1-3.svg" alt="img" />
                  </div>
                  <h4 className="service-box_title h5">
                    <Link to="/service-details">Government Solutions</Link>
                  </h4>
                  <p className="service-box_text">
                    Secure, compliant, and scalable software and IT solutions for 
                    government projects and public sector initiatives.
                  </p>
                  <Link
                    to="/service-details"
                    className="global-btn style-border"
                  >
                    Read More
                    <img src="assets/img/icon/right-icon2.svg" alt="B Plus Technology" />
                  </Link>
                </div>
              </div>
            </div>
            <div className="p-3">
              <div className="service-box">
                <div className="service-box_content">
                  <div className="service-box_icon">
                    <img src="assets/img/icon/service-icon_1-4.svg" alt="img" />
                  </div>
                  <h4 className="service-box_title h5">
                    <Link to="/service-details">AI Innovation</Link>
                  </h4>
                  <p className="service-box_text">
                    AI-powered products and solutions that enable automation, 
                    intelligence, and data-driven decision-making.
                  </p>
                  <Link
                    to="/service-details"
                    className="global-btn style-border"
                  >
                    Read More
                    <img src="assets/img/icon/right-icon2.svg" alt="B Plus Technology" />
                  </Link>
                </div>
              </div>
            </div>
            <div className="p-3">
              <div className="service-box">
                <div className="service-box_content">
                  <div className="service-box_icon">
                    <img src="assets/img/icon/service-icon_1-1.svg" alt="img" />
                  </div>
                  <h4 className="service-box_title h5">
                    <Link to="/service-details">Smart Cities</Link>
                  </h4>
                  <p className="service-box_text">
                    Intelligent systems for smart governance, infrastructure management, 
                    and sustainable urban development.
                  </p>
                  <Link
                    to="/service-details"
                    className="global-btn style-border"
                  >
                    Read More
                    <img src="assets/img/icon/right-icon2.svg" alt="B Plus Technology" />
                  </Link>
                </div>
              </div>
            </div>
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default ServiceThree;
